import getCaretCoordinates from "textarea-caret";

export interface CaretPosition {
  top: number;
  left: number;
  height: number;
}

const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
export const getCaretPosition = (element: HTMLTextAreaElement): CaretPosition | null => {
  if (!isBrowser) return null;
  const selectionStart = element.selectionStart ?? 0;
  const { top: caretTop, left: caretLeft, height } = getCaretCoordinates(
    element,
    selectionStart
  );
  const rect = element.getBoundingClientRect();
  const top = rect.top + caretTop - element.scrollTop;
  const left = rect.left + caretLeft - element.scrollLeft;
  return { top, left, height };
};
